import $ from 'jquery';

$(document).ready(function () {
  bigSliderWidget();
});

function bigSliderWidget() {
  $('.js-big-slider-widget').each(function () {
    const $section = $(this);
    const $slider = $section.find('.big-slider-widget-slider');

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      centerMode: true,
      centerPadding: '18.5%',
      speed: 600,
      autoplay: false,
      cssEase: 'linear',
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            centerPadding: '150px',
          },
        },
        {
          breakpoint: 1024,
          settings: {
            centerPadding: '100px',
          },
        },
        {
          breakpoint: 767,
          settings: {
            centerPadding: '30px',
          },
        },
      ],
    });

    //variables
    const $track = $slider.find('.slick-track');
    let trackWidth = $track[0].scrollWidth;
    let rafId = null;
    let speed = 1;
    let pos = 0;
    let isHover = false;
    let isManual = false;
    let initialized = false;

    // Animation loop
    function animate() {
      if (rafId) return;

      const loop = function () {
        if (!isHover && !isManual && initialized) {
          pos -= speed;
          $track.css('transform', `translate3d(${pos}px, 0, 0)`);

          if (Math.abs(pos) > trackWidth / 2) {
            //clone slides dynamically
            const $slides = $track.children(
              '.slick-slide:not(.slick-cloned-dynamic)'
            );
            //cloning
            const $clones = $slides
              .clone(true)
              .addClass('slick-cloned-dynamic');
            $track.append($clones);
            //get width of all slides
            const $slidesAll = $track.children('.slick-slide');
            const totalWidth = $slidesAll.toArray().reduce((sum, el) => {
              return sum + $(el).outerWidth(true);
            }, 0);
            //set track width
            $track.css('width', totalWidth + 'px');
            //update
            trackWidth = totalWidth;
          }
        }
        rafId = requestAnimationFrame(loop);
      };

      rafId = requestAnimationFrame(loop);
    }

    function stopAnimate() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    //Initialize position after Slick setup
    $slider.on('setPosition', function () {
      if (!initialized) {
        //get initial position from Slick
        const matrix = $track.css('transform');
        if (matrix && matrix !== 'none') {
          const values = matrix.match(/matrix.*\((.+)\)/);
          if (values) {
            const parts = values[1].split(',');
            const tx = parseFloat(parts[4]) || 0;
            pos = tx;
          }
        }
        initialized = true;
        animate();
      }
    });

    // Hover stop / resume
    $slider.on('mouseenter', function () {
      isHover = true;
      stopAnimate();
    });
    $slider.on('mouseleave', function () {
      isHover = false;

      if (!isManual && initialized) {
        // Resume animation on mouseleave
        setTimeout(() => {
          if (!isManual && !isHover) animate();
        }, 20);
      }
    });

    // Prev/Next handling
    const handleManualSlide = (dir) => {
      if (isManual) return;
      isManual = true;
      cancelAnimationFrame(rafId);

      if (dir === 'next') {
        $slider.slick('slickNext');
      } else {
        $slider.slick('slickPrev');
      }

      // After slide change, sync position and resume animation
      $slider.one('afterChange', function () {
        //get updated position from Slick
        const matrix = $track.css('transform');
        if (matrix && matrix !== 'none') {
          const values = matrix.match(/matrix.*\((.+)\)/);
          if (values) {
            const parts = values[1].split(',');
            const tx = parseFloat(parts[4]) || 0;
            pos = tx;
          }
        }
        isManual = false;
        if (!isHover) animate();
      });
    };

    $slider.find('.slick-prev').on('click', function (e) {
      e.preventDefault();
      handleManualSlide('prev');
    });

    $slider.find('.slick-next').on('click', function (e) {
      e.preventDefault();
      handleManualSlide('next');
    });

    setInterval(() => {
      const $slides = $track.children('.slick-slide');
      if ($slides.length > 18) {
        const extraCount = $slides.length - 18;
        $slides.slice(0, extraCount).remove();
        pos = 0;
        $track.css('transform', `translate3d(${pos}px, 0, 0)`);
        trackWidth = $track[0].scrollWidth;
      }
    }, 10000);
  });
}
